import { API_BASE_PATH_ADMIN } from '../../constants';
import DefaultMapper from '../../dataProvider/DefaultMapper';

class BinGroupMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'payment/bingroups';
	}

	prepareUpdate({ params, options }) {
		options.url = `${API_BASE_PATH_ADMIN}/payment/bingroups/${params.data.id}`;
		options.method = 'PUT';
		const data = {
			name: params.data.groupName,
			binRanges: params.data.binRanges,
			description: params.data.groupDescription
		};
		options.body = JSON.stringify(data);
	}

	prepareCreate({ params, options }) {
		options.url = `${API_BASE_PATH_ADMIN}/payment/bingroups`;
		options.method = 'POST';
		const data = {
			name: params.data.groupName,
			binRanges: params.data.binRanges,
			description: params.data.groupDescription
		};
		options.body = JSON.stringify(data);
	}
}

export default BinGroupMapper;
